const NAVIGATION_MENU_DROPDOWNS = ['Developers', 'Solutions']

/**
 * Adjusts the height of the dropdown menu.
 *
 * @param element - The parent element of the dropdown menu.
 * @param subMenuHeight - The height of the submenu.
 */
function adjustDropdownMenuHeight(
  element: HTMLElement,
  subMenuHeight: number
): void {
  element.style.height = `${subMenuHeight}px`
}

/**
 * Sets the height and overflow for a submenu when it exceeds the window height.
 *
 * @param element - The submenu element.
 * @param navBarHeight - The height of the navigation bar.
 */
function setSubMenuHeightForOverflow(
  element: HTMLElement,
  navBarHeight: number
): void {
  const maxHeight = window.innerHeight - navBarHeight
  element.style.height = `${maxHeight}px`
  element.style.overflowY = 'scroll'
}

/**
 * Adjusts the parent menu height to match the submenu height.
 *
 * @param parentElement - The parent menu element.
 * @param subMenuHeight - The height of the submenu.
 */
function setParentMenuHeight(
  parentElement: HTMLElement,
  subMenuHeight: number
): void {
  parentElement.style.height = `${subMenuHeight}px`
}

/**
 * Handles submenu height adjustment when the submenu is taller than the parent menu.
 *
 * @param parentElement - The parent menu element.
 * @param subMenuElement - The submenu element.
 * @param subMenuHeight - The height of the submenu.
 * @param navBarHeight - The height of the navigation bar.
 */
function handleSubMenuHeightAdjustment(
  parentElement: HTMLElement,
  subMenuElement: HTMLElement,
  subMenuHeight: number,
  navBarHeight: number
): void {
  const isSubMenuTallerThanWindow =
    subMenuHeight > window.innerHeight - navBarHeight

  if (isSubMenuTallerThanWindow) {
    setSubMenuHeightForOverflow(subMenuElement, navBarHeight)
    setParentMenuHeight(parentElement, window.innerHeight - navBarHeight)
  } else {
    setParentMenuHeight(parentElement, subMenuHeight)
  }
}

/**
 * Adjusts the height of the submenu based on the parent menu height and window height.
 *
 * @param e - The event object from the click handler.
 * @param navBarHeight - The height of the navigation bar.
 */
export function subMenuHeightAdjustments(e: any, navBarHeight: number): void {
  e.currentTarget.nextElementSibling.style.height = 'auto'

  const parentMenuHeight =
    e.currentTarget.parentElement.parentElement.clientHeight
  const subMenuHeight = e.currentTarget.nextElementSibling.clientHeight

  if (parentMenuHeight < subMenuHeight) {
    handleSubMenuHeightAdjustment(
      e.currentTarget.parentElement.parentElement,
      e.currentTarget.nextElementSibling,
      subMenuHeight,
      navBarHeight
    )
    return
  }

  if (parentMenuHeight > subMenuHeight) {
    const isDropdownMenu = NAVIGATION_MENU_DROPDOWNS.includes(
      e.currentTarget.parentElement.parentElement.parentElement.firstChild.innerText.trim()
    )

    if (isDropdownMenu) {
      adjustDropdownMenuHeight(
        e.currentTarget.parentElement.parentElement,
        subMenuHeight
      )
      return
    }

    e.currentTarget.nextElementSibling.style.height = `${parentMenuHeight}px`
  }
}
